import update from 'immutability-helper';
import { createReducer } from '../../utils/redux/reducers.utils';
import {
  APPLICATION_WIPE_DATA,
  AI_UPDATE_STATE,
  AI_SET_MESSAGES,
  AI_SET_CONVERSATION_ID,
  AI_CLEAR_CONVERSATION,
} from '../actions';

const initialState = {
  isChatOpen: false,
  messages: [],
  conversationId: undefined,
};

const mergeState = (state, payload) => update(state, { $merge: payload });

const updateChatState = (state, { isChatOpen }) => mergeState(state, { isChatOpen });

const setMessages = (state, { messages }) => mergeState(state, { messages });

const setConversationId = (state, { conversationId }) => mergeState(state, { conversationId });

const clearConversation = state => mergeState(state, { messages: [], conversationId: undefined });

const cleanData = () => initialState;

const actionsRepo = {
  [AI_UPDATE_STATE]: updateChatState,
  [AI_SET_MESSAGES]: setMessages,
  [AI_SET_CONVERSATION_ID]: setConversationId,
  [AI_CLEAR_CONVERSATION]: clearConversation,
  [APPLICATION_WIPE_DATA]: cleanData,
};

export default createReducer({ initialState, actionsRepo });
